import React, { SVGProps } from 'react'
const SvgNotificationsInactive = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || 'var(--color-cta)'}
      fillRule="nonzero"
      d="M12.5 4.5c1.018 0 1.674.719 1.782 1.75 2.213.66 3.762 2.542 3.863 4.96l.005.253v1.09c0 .855.163 1.328.799 2.447l.134.233 1.225 1.968a.9.9 0 0 1 .013.882.876.876 0 0 1-.648.45l-.118.008h-4.42c.005.06.008.12.008.18-.002 1.298-1.114 2.337-2.465 2.337-1.352 0-2.464-1.04-2.464-2.337l.008-.18H5.451a.876.876 0 0 1-.767-.459.901.901 0 0 1-.034-.784l.054-.108 1.205-1.943c.709-1.223.916-1.72.939-2.529l.002-.166v-1.089c0-2.54 1.58-4.533 3.87-5.213.121-1.049.775-1.75 1.78-1.75Zm1.63 14.04-2.903.001a1.22 1.22 0 0 0-.013.18c0 .73.65 1.337 1.464 1.337s1.464-.608 1.465-1.337c0-.06-.005-.12-.014-.18ZM12.5 6.998c-2.595 0-4.536 1.769-4.645 4.246l-.005.22v1.09c0 .917-.155 1.493-.66 2.45l-.134.247-.289.51-1.105 1.781h4.89l.004-.006.01.006h4.224l.011-.006.002.006h4.538l-1.115-1.793c-.737-1.27-1.01-1.899-1.065-2.804l-.008-.185-.003-.207v-1.089c0-1.936-1.104-3.471-2.776-4.125l.004.042-.077-.07a4.935 4.935 0 0 0-.914-.242l-.042.003a.058.058 0 0 1-.048-.014 5.05 5.05 0 0 0-.797-.06Zm0-1.497c-.345 0-.592.174-.715.535a6.578 6.578 0 0 1 1.434.001c-.12-.356-.369-.536-.72-.536Z"
    />
  </svg>
)
export default SvgNotificationsInactive
